import {Utils, ApiClientCommunication} from 'neo-common';
import {Request} from './Request';
import {GameResponse} from '../Responses/GameResponse';

const action = 'Select';

/**
 * @class PickSelectRequest - request pick select
 */
export class PickSelectRequest extends Request<GameResponse> {
    /**
     * @property spot - Identifier of selected spot.
     */
    spot: number;

    constructor(spot: number, customData?: any) {
        super(customData);

        if (Utils.isNullOrUndefined(spot)) {
            throw new Error(`Argument "spot" is required to be specified!`);
        }

        this.spot = spot;
    }

    actionName(): string {
        return action;
    }

    createResponse(responseJson: ApiClientCommunication.Types.RawResponseType): GameResponse {
        return new GameResponse(responseJson);
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Requests/PickSelectRequest.ts
 **/